import React from 'react';

import { Breakpoint } from 'ui/style';
import { ContentCardType } from '../component';

const getState = (width: number): StepperConfigState => {
  const mobileWidthBreakpoint = Breakpoint.LG;

  const initialContentCards: ContentCardType[] = ['scripting', 'process_automation', 'machine_learning', 'machine_reasoning', 'zero_touch'];

  const isMobile = width < mobileWidthBreakpoint;
  const numberOfItemsPerPage = isMobile ? 1 : 3;
  const contentCards: ContentCardType[] = isMobile ? [...initialContentCards] : ['empty', ...initialContentCards, 'empty'];

  const state: StepperConfigState = {
    isMobile,
    numberOfItemsPerPage,
    contentCards,
  };

  return state;
};

interface StepperConfigState
  extends Readonly<{
    isMobile: boolean;
    numberOfItemsPerPage: number;
    contentCards: ContentCardType[];
  }> {}

export const useStepperConfig = () => {
  const [state, setState] = React.useState<StepperConfigState>(() => getState(window.innerWidth));

  React.useEffect(() => {
    const onResize = () => {
      setState(getState(window.innerWidth));
    };

    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, []);

  return state;
};
